/**
 * 深拷贝 Worker 导出的权威 B 样条求值定义。
 *
 * @param definition 原始定义。
 * @returns 与原始数据完全解耦的副本；未提供时返回 null。
 */
export function cloneSketchBSplineEvaluationDefinition(
    definition: SketchBSplineEvaluationDefinition | null | undefined,
): SketchBSplineEvaluationDefinition | null {
    if (!definition) {
        return null;
    }
    return {
        controlPoints: definition.controlPoints.map((point) => ({...point})),
        weights: [...definition.weights],
        degree: definition.degree,
        knots: [...definition.knots],
        firstParameter: definition.firstParameter,
        lastParameter: definition.lastParameter,
        periodic: definition.periodic,
    };
}
